/* eslint-disable */
<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <display-approved v-if="bookingSuggestionAccepted"></display-approved>
      <template v-else>
        <display-header></display-header>
        <error-banner v-if="error" :message="error" class="mb-2 mx-3"></error-banner>
        <summary-client></summary-client>
        <terms-and-conditions v-if="displayTerms"></terms-and-conditions>
        <display-header-summary v-else></display-header-summary>
        <div class="d-flex flex-column align-items-center w-100">
          <div class="section-header text-center px-0">
            <div v-if="recaptchaEnabled && displayRecaptcha">
              <turnstile-widget ref="turnstileWidget" @verified="handleRecaptchaToken" @errored="handleRecaptchaError"></turnstile-widget>
              <validation-message v-if="recaptchaMessage" :message="recaptchaMessage"></validation-message>
            </div>
            <terms-checkbox v-model="termsAccepted" :disabled="loading" @displayTerms="displayTerms = !displayTerms"></terms-checkbox>
            <validation-message v-if="termsMessage" :message="termsMessage" class="mb-2"></validation-message>
          </div>
        </div>
      </template>
    </div>
    <div class="fixed-buttons" v-if="!bookingSuggestionAccepted">
        <button @click="onValidatedChanged" class="btn btn-secondary w-100 ml-2" :disabled="updatingBookingSuggestion">
            Accept
            <span v-if="updatingBookingSuggestion" class="inline-loader"></span>
        </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import { mapActions, mapState } from 'vuex';
  import { ErrorHelper } from '@/helpers/ErrorHelper';
  import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin';
  import { RecaptchaSettingsCacheMixin } from '@/mixins/Booking/RecaptchaSettingsCacheMixin';
  import TermsAndConditions from '../Booking/TermsAndConditions.vue';
  import SummaryClientDetails from '../Booking/Anonymous/SummaryClientDetails.vue';
  import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue';
  import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue';
  import TurnstileWidget from '../Booking/TurnstileWidget.vue';
  import TermsAndConditionsCheckbox from '../Booking/TermsAndConditionsCheckbox.vue';
  import DisplayHeader from '../Booking/DisplayHeader.vue';
  import DisplayHeaderSummary from './DisplayHeaderSummary.vue';
  import DisplayApproved from './DisplayApproved.vue';

  export default {
    name: 'Confirmation',
    mixins: [SiteBookingSettingMixin, RecaptchaSettingsCacheMixin],
    props: {
      token: String
    },
    data() {
      return {
        displayTerms: false,
        termsAccepted: false,
        termsMessage: '',
        recaptchaMessage: '',
        completed: false,
        updatingBookingSuggestion: false,
        recaptcha: '',
        displayRecaptcha: false
      }
    },
    computed: {
      ...mapState('BookingSuggestion', [
        'bookingSuggestion'
      ]),
      ...mapState('BookingUpload', [
        'selectedPets'
      ]),
      loading() {
        return !!this.loadingSetting || !!this.fetchingRecaptchaSettings
      },
      bookingSuggestionUpdateModel() {
        return {
          token: this.token,
          recaptcha: this.recaptcha
        }
      },
      bookingSuggestionUpdateModelValid() {
        const model = this.bookingSuggestionUpdateModel;
        return this.recaptchaValid && !!model.token
      },
      recaptchaEnabled() {
        return !!this.recaptchaSettings ? this.recaptchaSettings.recaptchaEnabled : false;
      },
      recaptchaValid() {
        return !this.recaptchaEnabled || !!this.bookingSuggestionUpdateModel.recaptcha;
      },
      bookingSuggestionStatus() {
        return !!this.bookingSuggestion && this.bookingSuggestion.status ?  this.bookingSuggestion.status : null; 
      },
      bookingSuggestionAccepted() {
        return !!this.bookingSuggestionStatus && this.bookingSuggestionStatus.id === 2 ? true : false;
      },
      canUpdateBookingSuggestion() {
        return !this.completed;
      }
    },
    watch: {
      termsAccepted(value) {
        this.validateTerms();
        if(!!value && !this.displayRecaptcha && !this.completed) {
          this.displayRecaptcha = true;
        }
      },
      recaptcha(value) {
        if(!!value) {
          this.onValidatedChanged();
        }
      }
    },
    methods: {
      ...mapActions('BookingSuggestion', [
        'acceptBookingSuggestion'
      ]),
      handleRecaptchaToken(token) {
        this.recaptcha = token;
        this.validateTerms();
      },
      handleRecaptchaError() {
        this.recaptcha = '';
      },
      validateTerms() {
        this.termsMessage = (!!this.termsAccepted || !!this.completed) ? '' : 'Please agree to the Terms and Conditions.';
      },
      validateRecaptcha() {
        this.recaptchaMessage = !!this.recaptchaValid ? '' : 'Please answer reCAPTCHA.';
      },
      onValidatedChanged() {
        const self = this;
        self.validateTerms();
        self.validateRecaptcha();
        if (!self.canUpdateBookingSuggestion || !!self.termsMessage || !self.recaptchaValid) {
          return;
        }
        self.tryAcceptBookingSuggestion();
      },
      tryAcceptBookingSuggestion() {
        const self = this;
        if(!self.bookingSuggestionUpdateModelValid) {
          return;
        }
        self.error = '';
        self.updatingBookingSuggestion = true;
        self.acceptBookingSuggestion(self.bookingSuggestionUpdateModel)
          .then(() => { self.completed = true })
          .catch(error => {
            self.error = ErrorHelper.getError(error)
            if(self.$refs.turnstileWidget) {
              self.recaptcha = ''
              self.$refs.turnstileWidget.resetWidget();
            }
          })
          .finally(() => { self.updatingBookingSuggestion = false });
      }
    },
    components: {
      'terms-and-conditions': TermsAndConditions,
      'summary-client': SummaryClientDetails,
      'error-banner': ErrorBanner,
      'validation-message': ValidationMessage,
      'turnstile-widget': TurnstileWidget,
      'terms-checkbox': TermsAndConditionsCheckbox,
      'display-header': DisplayHeader,
      'display-header-summary': DisplayHeaderSummary,
      'display-approved': DisplayApproved
    }
  }
</script>

<style scoped>
  @media (max-width: 768px) {
    .time-slots {
      height: max-content;
      min-height: 20vh !important;
    }
  }
</style>